import React from 'react';
import { useTranslations } from 'next-intl';

import { StyledImageSkeleton } from './image.style';

const ImageSkeleton = () => {
  const t = useTranslations();
  return <StyledImageSkeleton>{t('image.loading')}</StyledImageSkeleton>;
};

export default ImageSkeleton;
